export default "__VITE_ASSET__BYgTw_di__"